import React from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router';
import LocalizedStrings from 'react-localization';
import warning from '../img/icon-warning.svg'

function ApplyInfo(props) {
  const values = queryString.parse(props.location.search);
  const item = JSON.parse(localStorage.getItem('offers')).offers.filter((el) => el.insuranceCompanyCode === values.id)[0];
  const tarif = [item.light, item.popular, item.premium].filter((el) => el.name === values.type)[0];
  const tarifInformation = {
    name: item.insuranceCompanyCode,
    tarif
  };

  const handleRedirect = (e) => {
    e.preventDefault();
    const idx = props.location.search.indexOf('&type');
    const url = props.location.search.slice(0, idx);
    props.history.push({
      pathname: props.locale === 'ua' ? '/uk/kasko/info' : '/kasko/info',
      search: url,
    });
  };

  localStorage.setItem('tarif', JSON.stringify(tarifInformation));

  const strings = new LocalizedStrings({
    ru: {
      bonus: 'Бонусы',
      price: 'Стоимость',
      show: 'показать все',
      hide: 'свернуть все',
      back: 'вернуться назад',
      franchiseDamage: 'повреждения',
      franchiseStealing: 'угон',
      warning: 'Стоимость полиса ориентировочная. Финальная стоимость будет рассчитана и озвучена вашей страховой компанией'
    },
    ua: {
      bonus: 'Бонуси',
      price: 'Вартість',
      show: 'Показати всі',
      hide: 'Згорнути всі',
      back: 'повернутися назад',
      franchiseDamage: 'пошкодження',
      franchiseStealing: 'викрадення',
      warning: "Вартість поліса орієнтовна. Фінальна вартість буде розрахована і озвучена вашою страховою компанією"
    },
  });

  strings.setLanguage(props.locale);

  return (
    <div className="apply-info">
      <a onClick={handleRedirect} href="#/" className="btn-back"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L1 9" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>{strings.back}</a>

      <div className="logo-company">
        <picture>
          <source type="image/webp" srcSet={item.insuranceCompanyLogoWebp} />
          <img src={item.insuranceCompanyLogoPng} alt={item.insuranceCompanyName} />
        </picture>
      </div>
      <div className="table">
        <div className="row">
          <div className="tit">
            <p>Пакет</p>
          </div>
          <div className="value">
            <p>«{tarif.name}»</p>
          </div>
        </div>
        <div className="row">
          <div className="tit">
            <p>Франшиза ({strings.franchiseDamage})</p>
          </div>
          <div className="value">
            <p>{tarif.dtpFranchise}%</p>
          </div>
        </div>
        <div className="row">
          <div className="tit">
            <p>Франшиза ({strings.franchiseStealing})</p>
          </div>
          <div className="value">
            <p>{tarif.ugonFranchise}%</p>
          </div>
        </div>
        <div className="row">
          <div className="tit">
            <p>{strings.bonus}</p>
          </div>

          {/* bonuses */}
          <div className="value">
            {
              tarif.bonuses.map((el, id) => (<p key={id}>{el}</p>))
            }
            {/* className="btn btn-more btn-show"><p><span className="txt-show">{strings.show}</span><span className="txt-hide">{strings.hide}</span></p><svg width={10} height={7} viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1L5 5.17391L1 1" stroke="#0A7E3E" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M9 1L5 5.17391L1 1" stroke="#189851" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg></div> */}
          </div>
          {/* End bonuses */}

        </div>
        <div className="row">
          <div className="tit">
            <p>Тариф</p>
          </div>
          <div className="value">
            <p>{tarif.tarif}%</p>
          </div>
        </div>
        <div className="row">
          <div className="tit">
            <p>{strings.price}</p>
          </div>
          <div className="value">
            <p className="price">
              {
                tarif.amountWithDiscount ? (
                  Math.floor(tarif.amountWithDiscount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                ) : (
                    Math.floor(tarif.amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                  )
              }
              &nbsp;грн</p>
          </div>
        </div>
      </div>

      {/* {item.with_cashback.status === true
      && (
      <div className="action-tariff action-block flex flex_j-space-between">
        <div className="flex">
          <div className="tit">акция</div>
          <h2>Получи <span className="color-blue">10% кешбэка</span> по Промокоду «ALFA»</h2>
        </div>
        <div className="date">до {item.with_cashback.date}</div>
      </div>
      )} */}
      <div className="flex warning-msg"><img src={warning} alt=""/>{strings.warning}</div>
    </div>
  );
}

export default withRouter(ApplyInfo);
